import useMemberSettings from '../member/useMemberSettings';
import useFeatureSettingsUpdate from './useFeatureSettingsUpdate';
import useNestedSettingsUpdate from './useNestedSettingsUpdate';

export default function useEquipmentManagementSettingsUpdate() {
  const memberSettings = useMemberSettings();
  return useNestedSettingsUpdate(
    useFeatureSettingsUpdate('managementLists'),
    memberSettings?.web?.features?.managementLists?.equipment,
    'equipment'
  );
}
